<template>
    <div class="pa-4">
        <v-data-table :headers="headers" :items="bosses" :items-per-page="itemsPerPage">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Список ЦОП</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-dialog @click:outside.prevent="close" v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="gray white--text" rounded class="mb-2" v-bind="attrs" v-on="on">
                                Добавить начальника ЦОП
                            </v-btn>
                        </template>
                        <v-card>
                            <v-form ref="addForm" @submit.prevent="save">
                                <v-card-title>
                                    <span class="text-h5">Добавление начальника ЦОП</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col>
                                            <v-text-field
                                                :rules="[validationRules.required]"
                                                color="gray"
                                                v-model="newItemForm.boss_name"
                                                label="ФИО начальника ЦОП"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <pre-trial-date-picker required :outlined="false" label="Дата начала" :date.sync="newItemForm.date_begin" />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-select
                                                :rules="[validationRules.required]"
                                                v-model="newItemForm.customer_service_center_rid"
                                                :items="serviceList"
                                                label="Выберете"
                                                item-text="customer_service_center_name"
                                                item-value="record_id"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <StylusSign ref="stylus" />
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="gray" outlined @click="close">
                                        Отмена
                                    </v-btn>
                                    <v-btn type="submit" color="gray white--text">
                                        Сохранить
                                    </v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card>
                            <v-card-title class="text-h5">Вы действительно хотите удалить?</v-card-title>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="gray" outlined text @click="closeDelete">Отмена</v-btn>
                                <v-btn color="gray" class="white--text" @click="deleteItem">Да</v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog @click:outside.prevent="closeEdit" v-model="dialogEdit" max-width="500">
                        <v-card>
                            <v-form ref="editForm" @submit.prevent="editItem">
                                <v-card-title class="text-h5">Изменить начальника ЦОП</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col>
                                            <v-container>
                                                <v-row>
                                                    <v-col>
                                                        <v-text-field
                                                            :rules="[validationRules.required]"
                                                            color="gray"
                                                            v-model="editItemForm.boss_name"
                                                            label="ФИО начальника ЦОП"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col>
                                                        <pre-trial-date-picker
                                                            required
                                                            :outlined="false"
                                                            label="Дата начала"
                                                            :date.sync="editItemForm.date_begin"
                                                        />
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col>
                                                        <v-select
                                                            :rules="[validationRules.required]"
                                                            v-model="editItemForm.customer_service_center_rid"
                                                            :items="serviceList"
                                                            label="Выберете"
                                                            item-text="customer_service_center_name"
                                                            item-value="record_id"
                                                        />
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col>
                                                        <StylusSign ref="editStylus" />
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="gray" outlined @click="closeEdit">
                                        Отмена
                                    </v-btn>
                                    <v-btn type="submit" color="gray white--text">
                                        Сохранить
                                    </v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click.stop="openEditDialog(item)">
                    mdi-pencil
                </v-icon>
                <v-icon small @click.stop="openDeleteDialog(item)">
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </div>
</template>
<script>
import translate from '@/utils/translate.util';
import { mapActions, mapGetters } from 'vuex';
import PreTrialDatePicker from '@/components/pre-trial-notices/PreTrialDatePicker.vue';
import { validationRules } from '@/utils/validationRules';
import { refsService } from '@/services/apiRequests/refs.service';
import StylusSign from '@/components/sign_document/StylusSign.vue';
import signService from '@/services/apiRequests/sign.service';

export default {
    name: 'CenterBosses',
    components: { StylusSign, PreTrialDatePicker },
    data: () => {
        return {
            headers: [
                {
                    text: 'Название',
                    value: 'customer_service_center_name'
                },
                {
                    text: 'Дата',
                    value: 'date_begin'
                },
                {
                    text: 'имя',
                    value: 'csc_boss_name'
                },
                {
                    text: 'Действия',
                    value: 'actions'
                }
            ],
            itemsPerPage: 10,
            currentItem: 0,
            dialog: false,
            dialogDelete: false,
            dialogEdit: false,
            itemIdToDelete: null,
            newItemForm: {
                date_begin: '',
                boss_name: '',
                customer_service_center_rid: ''
            },
            defaultNewItemForm: {
                date_begin: '',
                boss_name: '',
                customer_service_center_rid: ''
            },
            editItemForm: {
                date_begin: '',
                boss_name: '',
                customer_service_center_rid: ''
            }
        };
    },
    computed: {
        validationRules() {
            return validationRules;
        },
        ...mapGetters('refs', ['getCenterBosses', 'getCustomerServiceList']),
        bosses() {
            return translate(this.getCenterBosses, 'full', this.$i18n.locale);
        },
        serviceList() {
            return translate(this.getCustomerServiceList, 'full', this.$i18n.locale);
        }
    },
    methods: {
        ...mapActions('refs', ['fetchCenterBosses', 'fetchCustomerServiceList']),
        initialize() {
            this.fetchBosses();
            this.fetchCustomerServiceList();
        },
        async editItem() {
            if (!this.$refs.editForm.validate()) return;
            const dataStylus = this.$refs.editStylus.$refs.signaturePad.saveSignature();
            const response = await refsService.addCenterBoss(this.editItemForm);
            if (!response.successfull) return;
            const { record_id } = response.data;
            const payload = { record_id, boss_sign: dataStylus.data };
            const signResponse = await signService.bossSign(payload);
            if (!signResponse) return;
            await this.fetchBosses();
            this.closeEdit();
        },

        openEditDialog(item) {
            this.dialogEdit = true;
            this.editItemForm = {
                date_begin: item.date_begin,
                boss_name: item['csc_boss_name'],
                customer_service_center_rid: item.customer_service_center_rid
            };
            this.editItemForm.record_id = item.record_id;
        },

        openDeleteDialog(item) {
            this.dialogDelete = true;
            this.itemIdToDelete = item.record_id;
        },

        async deleteItem() {
            await refsService.deleteCenterBoss(this.itemIdToDelete);
            this.closeDelete();
            await this.fetchBosses();
        },

        close() {
            this.dialog = false;
            this.newItemForm = { ...this.defaultNewItemForm };
            this.$refs.addForm.resetValidation();
            this.$refs.stylus.$refs.signaturePad.clearSignature();
        },

        closeDelete() {
            this.dialogDelete = false;
        },

        closeEdit() {
            this.dialogEdit = false;
            this.editItemForm = { ...this.defaultNewItemForm };
            this.$refs.editStylus.$refs.signaturePad.clearSignature();
        },

        async fetchBosses() {
            await this.fetchCenterBosses({ itemsPerPage: this.itemsPerPage, currentItem: this.currentItem });
        },

        async save() {
            if (!this.$refs.addForm.validate()) return;
            const dataStylus = this.$refs.stylus.$refs.signaturePad.saveSignature();
            const response = await refsService.addCenterBoss(this.newItemForm);
            if (!response.successfull) return;
            const { record_id } = response.data;
            const payload = { record_id, boss_sign: dataStylus.data };
            const signResponse = await signService.bossSign(payload);
            if (!signResponse) return;
            await this.fetchBosses();
            this.close();
        }
    },
    created() {
        this.initialize();
    }
};
</script>

<style scoped></style>
